import Vue from 'vue';

Vue.filter('projectId', function (obj) {
  if (obj) {
    let id = obj.id.toString();
    return `P-${id.padStart(6, '0')}`;
  }
})
